import React from 'react';

import { SELECT_AN_OPTION_LABEL } from '../../constants/common';
import cn from 'classnames';
import './fields.css';
import { Dropdown } from 'primereact/dropdown';

const SelectFieldImp = ({
  field,
  form,
  onChange,
  className,
  hasError,
  ...restProps
}) => {
  const handleChange = (e) => {
    const { value } = e.target;

    if (onChange) {
      onChange(value);
    }

    if (!form) {
      return;
    }

    if (
      value === SELECT_AN_OPTION_LABEL ||
      restProps?.options?.find(
        (option) => option.label === value && !option.value,
      )
    ) {
      form.setFieldValue(field.name, '');
    } else {
      form.setFieldValue(field.name, value);
    }
  };

  const handleBlur = () => {
    form.setFieldTouched(field.name, true);
  };

  return (
    <Dropdown
      {...restProps}
      {...field}
      placeholder={
        restProps?.placeholder ||
        restProps?.options.find(
          (option) => !option.value || option.value === SELECT_AN_OPTION_LABEL,
        )?.label
      }
      options={restProps?.options.filter(
        (option) => option.value && option.value !== SELECT_AN_OPTION_LABEL,
      )}
      onChange={handleChange}
      onBlur={handleBlur}
      className={cn('select-field', className, hasError ? 'hasError' : '', {
        'select-placeholder': !field?.value,
      })}
    />
  );
};

export default React.memo(SelectFieldImp);
